import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: 'app-slide-toggle',
    templateUrl: 'slide-toggle.component.html',
    styleUrl: 'slide-toggle.component.scss',
    standalone: false
})
export class SlideToggleComponent {
    @Input() inputObject;
    @Input() checked: boolean;
    @Output() slideToggleEvent = new EventEmitter<boolean>();

    constructor(
        private dialog: MatDialog
    ) {}

    protected openConfirmationDialog(event, inputObject) {
        if (inputObject.hasOwnProperty('componentId') && this.checked && inputObject['isReferenced']) {
            event.preventDefault();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                data: {
                    dialogMessage: 'Warning: You are about to deactivate a component that '
                        + 'is in use by an active pipe class. Are you sure you would like to ' 
                        + 'continue?',
                }
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.onSlide(this.inputObject);
                } else {
                    (event.target as HTMLInputElement).checked = this.checked;
                }
            });

        } else {
            this.onSlide(this.inputObject);
        }
    }

    protected onSlide(inputObject) {
        inputObject.isActive = !inputObject.isActive;
        this.slideToggleEvent.emit();
    }
}